import React, { FC, useState } from "react";

import { Box, Button, Image } from "@chakra-ui/react";
import SafeImage from "./SafeImage";
import { RestrictedModalItem } from "./RegularClassroomUser/utils";
import RulePencilIcon from "@/assets/RulePencilIcon.svg?url";
import { CloseButton } from "./shared/CloseButton";

type Props = {
	// defines the modal item structure
	// this can be website or an app
	modalItem: {
		url: string;
		id: string;
		title: string;
	};
	isMonitorMode: boolean;
	classIsActive: boolean;
	canCloseTab: boolean;
	item: RestrictedModalItem;
	forceCloseTab: (tabId?: string, user?: object, setLoading?: boolean) => void;
	handleOpenRuleModal: (data: { url: string; id: string }) => void;
	itemKey: string;
	canCreateRule: boolean;
};

export const RestrictedWebsiteOrAppItem: FC<Props> = ({
	modalItem,
	isMonitorMode,
	classIsActive,
	canCloseTab,
	forceCloseTab,
	handleOpenRuleModal,
	itemKey,
	item,
	canCreateRule = true,
}) => {
	const [isClosed, changeClosed] = useState(false);

	const handleClose = () => {
		forceCloseTab(item.tab_id);
		changeClosed(true);
	};

	const disableClose = () => {
		return !item.tab_id || isClosed || !classIsActive;
	};

	const openRuleModal = () => {
		handleOpenRuleModal(modalItem);
	};

	return (
		<Box
			className={!isClosed ? "WebsiteOrSignatureListModal_infoElement" : "WebsiteOrSignatureListModal_infoElement--closed"}
			key={itemKey}
		>
			{(item.favIcon || item.favicon) && (
				<SafeImage styleClassName="WebsiteOrSignatureListModal_favicon" src={item.favIcon || item.favicon || ""} />
			)}
			<Box flex={30} className={"WebsiteOrSignatureListModal_infoTitle"} title={modalItem.url ? modalItem.url : modalItem.id}>
				{modalItem.title}
			</Box>
			{!isMonitorMode && item.canApplyRule && canCreateRule && (
				<Button onClick={openRuleModal} className={"WebsiteOrSignatureListModal_ruleButton"} background={"transparent"}>
					<Box>
						<Image className={"WebsiteOrSignatureListModal_ruleIcon"} src={RulePencilIcon} alt="" />
					</Box>
					<Box className={"WebsiteOrSignatureListModal_ruleText"}>Rule</Box>
				</Button>
			)}
			{canCloseTab && item.canApplyRule && (
				<Box flex={1}>
					<CloseButton
						tooltipText="Close Tab"
						tooltipId={(item?.tab_id || "") + "_closeTabTooltip"}
						disabled={disableClose()}
						onClick={handleClose}
					/>
				</Box>
			)}
		</Box>
	);
};
